module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2258ea6dfe9ad15440ca55aca291698d.svg";